// Module
var code = "<div class=\"row form-group\"> <div class=\"col-xs-6\"> <label for=\"{{labelName}}Input\">{{labelName}}</label> <input type=\"text\" name=\"{{labelName}}Input\" class=\"form-control\" ng-model=\"ngModel\"/> </div> </div> ";
// Exports
module.exports = code;